export let env;
export let Constants; 

export function setEnv(environment, options = {}) {    
    env = environment;
    let host_prefix = env === "prod" ? "" : env;
    
    // Determine if running locally based on options or auto-detection
    // This works without passing options - it will auto-detect localhost environments
    const isLocalDev = options?.isLocalDev !== undefined ? options?.isLocalDev : (
        typeof window !== 'undefined' && 
        (window?.location?.hostname === 'localhost' || window?.location?.hostname?.includes('127.0.0.1'))
    );
    
    Constants = {
        AuthUrl: `https://tsmaa7zvv5.execute-api.us-east-1.amazonaws.com/${env}/auth`,
        CampaignDataUrlV1: `https://${host_prefix}mediaops-api.annalect.com/${env}/campaigns`,
        CampaignDataUrl: `https://${host_prefix}mediaops-api.annalect.com/${env}/v2/campaigns`,
        LoginRedirectUrl: `https://${host_prefix}omni.annalect.com/extsso?resourcekey=an_mediaops&redirecturl=`,
        MediaOpsDevUrl: isLocalDev ? `http://localhost:5173/` : `https://${host_prefix}mediaops.annalect.com/`,
        GetOmniProfileUrl: `https://${host_prefix}mediaops-api.annalect.com/${env}/profile`,
        taxonomyUrl: `https://${host_prefix}mediaops-api.annalect.com/${env}/taxonomy`,
        taxonomiesUrl: `https://${host_prefix}mediaops-api.annalect.com/${env}/api/v1/media_ops/taxonomies`,
        ExportPlacementsUrl: `https://${host_prefix}mediaops-api.annalect.com/${env}/download/placement-templates/`,
        ExportUrl: `https://${host_prefix}mediaops-api.annalect.com/${env}/api/export/taxonomyids/`,
        ClientDataUrl: `https://${host_prefix}mediaops-api.annalect.com/${env}/clients`,
        ClientV2DataUrl: `https://${host_prefix}mediaops-api.annalect.com/${env}/v2/client`,
        enumerationsUrl: `https://${host_prefix}mediaops-api.annalect.com/${env}/api/v1/media_ops/enumerations`,
        exportTaxonomiesUrl: `https://${host_prefix}mediaops-api.annalect.com/${env}/download/delivered-templates/`,
        MediaOceanStatus: 'Ready to process',
        AllHierarchyUrl: `https://${host_prefix}mediaops-api.annalect.com/${env}/data_templates`,
        hierarchyColumnOptionsUrl: `https://${host_prefix}mediaops-api.annalect.com/${env}/external_columns`,
        vendorMappingUrl: `https://${host_prefix}mediaops-api.annalect.com/${env}/api/v1/media_ops/vendor_mappings`,
        plannedVendorMappingUrl: `https://${host_prefix}mediaops-api.annalect.com/${env}/clients/`,
        PlacmentsUrl: `https://${host_prefix}mediaops-api.annalect.com/${env}/api/v1/media_ops/campaigns/`,
        CampaignDataUrlV2: `https://${host_prefix}mediaops-api.annalect.com/${env}/v2/campaigns`,
        SystemParametersUrl: ` https://${host_prefix}mediaops-api.annalect.com/${env}/client_configurations`,
        ExportPlacementsUrlV2: `https://${host_prefix}mediaops-api.annalect.com/${env}/v2/download/placement-templates/`,
        PlacementSyncUrlV2: `https://${host_prefix}mediaops-api.annalect.com/${env}/v2/campaigns`,
        CampaignSyncUrl: `https://${host_prefix}mediaops-api.annalect.com/${env}/clients`,
        PlacementTemplateUrl: `https://${host_prefix}mediaops-api.annalect.com/${env}/download`,
        DownloadCampaignTemplateUrl: `https://${host_prefix}mediaops-api.annalect.com/${env}/v2/download/orphan-campaign-template`,
        UploadCampaignTemplateUrl: `https://${host_prefix}mediaops-api.annalect.com/${env}/v2/campaigns/bulk/map`
    }
}

export const ServedByOptions = [
    {label: '3rd party', value: '3rd party'},
    {label: 'Site', value: 'Site'},
    {label: 'Other', value: 'Other'}    
]

export const BuyType = [
    {label: 'Standalone', value: 'Standalone'}
];

export const BuyCategoryOrMerketplace = [
    {label: 'Standard',value: 'Standard'},
    {label: 'Pre-roll',value: 'Pre-roll'}
];

export const Marketplace = [
    {label: 'Display', value:'Display'},
    {label: 'Video', value:'Video'}
];

export const DimensionsPosition = [
    {label: 'Medium Rectangle', value:'Medium Rectangle'},
    {label: 'Wide Skyscrapper', value:'Wide Skyscrapper'},
    {label: 'Leaderboard', value:'Leaderboard'},
    {label: 'In-Banner Video', value:'In-Banner Video'}
];

export const UnitDimentions = [
    {label: '120 x 240 - Vertical Banner',value: '120 x 240'},
    {label: '250 x 250 - Square Pop-Up',value: '250 x 250'},
    {label: '468 x 60 - Full Banner',value: '468 x 60'},
    {label: '120 x 60 - Button 2',value: '120 x 60'},
    {label: '300 x 100 - 3:1 Rectangle',value: '300 x 100'},
    {label: '720 x 300 - Pop-Under',value: '720 x 300'},
    {label: '120 x 600 - Skyscraper',value: '120 x 600'},
    {label: '300 x 1050 - Portrait',value: '300 x 1050'},
    {label: '728 x 90 - Leaderboard',value: '728 x 90'},
    {label: '120 x 90 - Button 1',value: '120 x 90'},
    {label: '300 x 250 - Medium Rectangle',value: '300 x 250'},
    {label: '970 x 250 - Billboard',value: '970 x 250'},
    {label: '125 x 125 - Square Button',value: '125 x 125'},
    {label: '300 x 250 - Sidekick',value: '300 x 250'},
    {label: '970 x 250 - Sidekick',value: '970 x 250'},
    {label: '160 x 600 - Wide Skyscraper',value: '160 x 600'},
    {label: '300 x 600 - Filmstrip',value: '300 x 600'},
    {label: '970 x 90 - Pushdown',value: '970 x 90'},
    {label: '180 x 150 - Rectangle',value: '180 x 150'},
    {label: '300 x 600 - Half Page Ad',value: '300 x 600'},
    {label: '970 x 90 - Slider',value: '970 x 90'},
    {label: '234 x 60 - Half Banner',value: '234 x 60'},
    {label: '300 x 600 - Sidekick',value: '300 x 600'},
    {label: 'N/A - N/A',value: 'N/A x N/A'},
    {label: '240 x 400 - Vertical Rectangle',value: '240 x 400'},
    {label: '336 x 280 - Large Rectangle',value: '336 x 280'},
    {label: '88 x 31 - Micro Bar',value: '88 x 31'}
];
export const CostMethods = [
    {label: 'CPM',value: 'CPM'},
    {label: 'CPC',value: 'CPC'},
    {label: 'Flat',value: 'Flat'}
];

export const Providers = [
    {label: 'faceb0ok',value: 'FB'},
    {label: 'twitter',value: 'TT'},
    {label: 'YouTube', value: 'YouTube'}
];

export const UnitType = [
    {label: 'Impressions',value: 'Impressions'},
    {label: 'Clicks',value: 'Clicks'}
]
export const payloads = [
    {label: 'Impressions',value: 'Impressions'},
    {label: 'Clicks',value: 'Clicks'}
]

export const taxonomyTypes = {
    'socialdirectpackage': '62825466-6138-45e7-9c1d-d47db3a6f23f',
    'socialdirectplacement': '5bbd0aad-6b66-4cb0-96b3-3aa307d24a0e',
    'socialdirectlineitem':'6b435648-329b-4882-acfa-f013a149fca7',
    'socialdirectcreative':'834f573b-5ac0-4885-8c26-a20e4c390787',
    'socialprogrammaticpackage': 'da69f6e6-363a-40ae-9f83-900e49cbabde',
    'socialprogrammaticplacement': '1d7454da-cd0f-4ac0-9337-83174a2bbbe2',
    'socialprogrammaticlineitem': '07210e8d-cba3-4c65-8b8b-ae407a06703e',
    'socialprogrammaticcreative': 'bbab62b5-5aa8-4a2f-8549-b6fad1c02ad2',
    'defaultplacement': '6ed9ee8e-78a9-4262-b24b-2ff1f44da498',
    'campaign': 'd47a533b-0fc7-41e2-a9fd-4eea6d127436', 
    'directpackage':'76e5114a-d2b8-48d4-9b83-1137bd73ed1c',
    'directline':'fb926bed-913f-4266-a598-bef02760519a',
    'directplacement':'cf6ebce5-1d1d-40ed-9dea-22e6b5e29c86', 
    'directcreative':'c9b90ec7-0a19-488a-913e-2dbcc117982f',
    'programmaticpackage': 'd3e3cbc5-2366-4e05-bd4f-e33e69fd61db',
    'programmaticplacement': '0bd2f587-e8a7-490b-a8c4-781aa1a3c29b', 
    'programmaticline':'6c0f5c20-b34a-42d8-bd55-bfa0a0e5dc8a', 
    'programmaticcreative':'2f6d6ec4-2f18-4760-b02d-cb4cc57905f4', 
    'search': 'f8e54413-6b65-46ac-a24b-05172820663b', 
    'feeorder': '83da6cc1-99d8-4190-b2a0-53d3709d9063',
    'networkttvpackage':'ed245cf2-dff6-42ed-b3f7-fd503c7616b2',
    'networktvestimatename':'d7ae6948-01eb-4b71-bd32-571481e18a31',
    'offlinepackage':'4caacffa-c483-4662-997d-03b58c5aab39',
    'offlineestimatename':'4099d352-6b1d-4962-bcf9-ce640055d5fc',
    'oohpackage':'0cc1261e-5417-445c-b862-af185c60f269',
    'oohestimatename':'f49c36d6-608a-4e42-8710-3905e2564d2e',
}

export const impressionsMethod = [
    {id: 'CPM',value: 'CPM'},
    {id: 'CTR',value: 'CTR'}
]
export const messages = {
    'programmaticCostAmount': 'Child item(s) total cost cannot exceed package total cost, Please review'
}

export const placementCreateMenuTypes =  {
    "Direct": {
        "Package": {"title": "Package", "type": "Direct", "taxonomyType": "DirectPackage", "taxonomyData": "directPackageTaxonomyData"},
        "Placement": {"title": "Placement", "type": "Direct", "taxonomyType": "DirectPlacement", "taxonomyData": "placementTaxonomyData"},
        "Line Item": {"title": "Line Item", "type": "Direct", "taxonomyType": "DirectLine", "taxonomyData": "directLineTaxonomyData"}
    }, 
    "Programmatic": {
        "Package": {"title": "Package", "type": "Programmatic", "taxonomyType": "ProgrammaticPackage", "taxonomyData": "programmaticPackageTaxonomyData"},
        "Placement": {"title": "Placement", "type": "Programmatic", "taxonomyType": "ProgrammaticPlacement", "taxonomyData": "programmaticPlacementTaxonomyData"},
        "Line Item": {"title": "Line Item", "type": "Programmatic", "taxonomyType": "ProgrammaticLine", "taxonomyData": "dspPackageTaxonomyData"}
    },
    "Social Direct": {
        "Package": {"title": "Package", "type": "Social Direct", "taxonomyType": "SocialPackage", "taxonomyData": "socialDirectPackageTaxonomyData"},
        "Placement": {"title": "Placement", "type": "Social Direct", "taxonomyType": "SocialPlacement", "taxonomyData": "socialDirectPlacementTaxonomyData"},
        "Line Item": {"title": "Line Item", "type": "Social Direct", "taxonomyType": "SocialLine", "taxonomyData": "socialDirectLineTaxonomyData"}
    },
    "Social Programmatic": {
        "Package": {"title": "Package", "type": "Social Programmatic", "taxonomyType": "SocialProgrammaticPackage", "taxonomyData": "socialProgrammaticPackageTaxonomyData"},
        "Placement": {"title": "Placement", "type": "Social Programmatic", "taxonomyType": "SocialProgrammaticPlacement", "taxonomyData": "socialProgrammaticPlacementTaxonomyData"},
        "Line Item": {"title": "Line Item", "type": "Social Programmatic", "taxonomyType": "SocialProgrammaticLine", "taxonomyData": "socialProgrammaticLineItemTaxonomyData"}
    },
    "Paid Search": {"title": "Paid Search", "type": "Search", "taxonomyType": "SearchPlacement", "taxonomyData": "searchPackageTaxonomyData"},
    "Fee type": {"title": "Fee type", "type": "Fee", "taxonomyType": "FeePlacement", "taxonomyData": "feeOrderTaxonomyData"},
    "Print": {
        "Offline Package": {"title": "Print Offline Package", "type": "Print", "taxonomyType": "OfflinePackage", "taxonomyData": "offlinePackageData"},
        "Offline Estimate Name": {"title": "Print Offline Estimate Name", "type": "Print", "taxonomyType": "OfflineEstimateName", "taxonomyData": "offlineEstimateNameData"}
    },
    "OOH": {
        "Offline Package": {"title": "DOOH Package", "type": "OOH", "taxonomyType": "OfflinePackage", "taxonomyData": "oohPackageData"},
        "Offline Estimate Name": {"title": "DOOH Placement", "type": "OOH", "taxonomyType": "OfflineEstimateName", "taxonomyData": "oohEstimateNameData"}
    },
    "Cinema": {
        "Offline Package": {"title": "Cinema Offline Package", "type": "Cinema", "taxonomyType": "OfflinePackage", "taxonomyData": "offlinePackageData"},
        "Offline Estimate Name": {"title": "Cinema Offline Estimate Name", "type": "Cinema", "taxonomyType": "OfflineEstimateName", "taxonomyData": "offlineEstimateNameData"}
    },
    "Other": {
        "Offline Package": {"title": "Other Offline Package", "type": "Other", "taxonomyType": "OfflinePackage", "taxonomyData": "offlinePackageData"},
        "Offline Estimate Name": {"title": "Other Offline Estimate Name", "type": "Other", "taxonomyType": "OfflineEstimateName", "taxonomyData": "offlineEstimateNameData"}
    },
    "Unallocated": {
        "Offline Package": {"title": "Unallocated Offline Package", "type": "Unallocated", "taxonomyType": "OfflinePackage", "taxonomyData": "offlinePackageData"},
        "Offline Estimate Name": {"title": "Unallocated Offline Estimate Name", "type": "Unallocated", "taxonomyType": "OfflineEstimateName", "taxonomyData": "offlineEstimateNameData"}
    },
    "National TV": {
        "Offline Package": {"title": "National TV Network Package", "type": "National TV", "taxonomyType": "NetworkPackage", "taxonomyData": "networkTvPackageData"},
        "Offline Estimate Name": {"title": "National TV Network Estimate Name", "type": "National TV", "taxonomyType": "NetworkEstimateName", "taxonomyData": "networkTvEstimateNameData"}
    },
    "Network Radio": {
        "Offline Package": {"title": "Network Radio Offline Package", "type": "Network Radio", "taxonomyType": "OfflinePackage", "taxonomyData": "offlinePackageData"},
        "Offline Estimate Name": {"title": "Network Radio Offline Estimate Name", "type": "Network Radio", "taxonomyType": "OfflineEstimateName", "taxonomyData": "offlineEstimateNameData"}
    },
    "Spot TV": {
        "Offline Package": {"title": "Spot TV Offline Package", "type": "Spot TV", "taxonomyType": "OfflinePackage", "taxonomyData": "offlinePackageData"},
        "Offline Estimate Name": {"title": "Spot TV Offline Estimate Name", "type": "Spot TV", "taxonomyType": "OfflineEstimateName", "taxonomyData": "offlineEstimateNameData"}
    },
    "Spot Radio": {
        "Offline Package": {"title": "Spot Radio Offline Package", "type": "Spot Radio", "taxonomyType": "OfflinePackage", "taxonomyData": "offlinePackageData"},
        "Offline Estimate Name": {"title": "Spot Radio Offline Estimate Name", "type": "Spot Radio", "taxonomyType": "OfflineEstimateName", "taxonomyData": "offlineEstimateNameData"}
    }
}
export const placementStatuOption = [
    {"id":"Accepted","value":"Accepted"},
    {"id":"Approved","value":"Approved"},
    {"id":"Error","value":"Error"},
    {"id":"Export Error","value":"Export Error"},
    {"id":"Needs Update","value":"Needs Update"},
    {"id":"Import Error","value":"Import Error"},
    {"id":"Not Exported","value":"Not Exported"},
    {"id":"Needs Approval","value":"Needs Approval"},
    {"id":"Not Synced","value":"Not Synced"},
    {"id":"Placement Sent","value":"Placement Sent"},
    {"id":"Synced","value":"Synced"},
    {"id":"Sync Error","value":"Sync Error"},
    {"id":"Updated","value":"Updated"},
]

// Configuration constants for vendor mapping service
export const VENDOR_CONFIG = {
    MEDIA_OCEAN: {
        NAME: "mediaOcean",
        SUPPLIER_FIELD_NAME: "Supplier Code",
        ERROR_MESSAGES: {
            INVALID_TAXONOMY: 'Invalid taxonomy response structure',
            ITEM_PROCESS_ERROR: 'Failed to process item:'
        }
    }
};

export const creativeMap = {
    "directCreativeTaxonomyData": ["Direct Creative", "DirectCreative"],
    "creativePackageTaxonomyData": ["Programmatic Creative", "ProgrammaticCreative"],
    "socialDirectCreativeTaxonomyData": ["Social Direct Creative", "SocialDirectCreative"],
    "socialProgrammaticCreativeTaxonomyData": ["Social Programmatic Creative", "SocialProgrammaticCreative"],
};

export const AGGRID_LICENCE_KEY = "Using_this_{AG_Charts_and_AG_Grid}_Enterprise_key_{AG-085728}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{Omnicom_Media_Group}_is_granted_a_{Single_Application}_Developer_License_for_the_application_{MOH}_only_for_{4}_Front-End_JavaScript_developers___All_Front-End_JavaScript_developers_working_on_{MOH}_need_to_be_licensed___{MOH}_has_been_granted_a_Deployment_License_Add-on_for_{1}_Production_Environment___This_key_works_with_{AG_Charts_and_AG_Grid}_Enterprise_versions_released_before_{15_April_2026}____[v3]_[0102]_MTc3NjIwNzYwMDAwMA==780dfc461f07f19735794c1fc5347401";